import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';
import Icon from './Icon';

const GoogleSignInButton = ({ clickHandler }) => (
  <Button type="button" id="google-sign-in" onClick={clickHandler}>
    <Icon name="google-g" verticalAlign="middle" />
    Continue with Google
  </Button>
);

GoogleSignInButton.propTypes = {
  clickHandler: PropTypes.func.isRequired,
};

export default GoogleSignInButton;
